<template>
  <div>
    <!-- 콜렉션그룹 사용 -->
    <div v-if="!hasItem || (categorySettings.useCollectionGroup.use)" class="formGroup mb30">
      <div class="groupLabel mb5">아이템 그룹</div>
      <div v-if="categorySettings.useCollectionGroup.use" class="mt5">
        <p v-if="categorySettings.useCollectionGroup.collectionClasses.length === 0" class="colorRed">아이템 분류 항목을 설정해주세요.</p>
        <button type="button" class="btn btnRound btnWhite" @click="setItemClasses">아이템 분류 관리</button>
      </div>
      <div v-else-if="!hasItem" class="checkbox">
        <input type="checkbox" id="use_collection_group" :checked="categorySettings.useCollectionGroup.use" @click="setUseCollectionGroup($event)">
        <label for="use_collection_group">{{ locale.activate }}</label>
      </div>
    </div>
    <!-- //콜렉션그룹 사용 -->
     
    <!-- 담기 허용 -->
    <div class="formGroup mb30">
      <div class="groupLabel mb5">{{ locale.use_collection }}</div>
      <div class="checkbox">
        <input type="checkbox" id="use_category_save_collection" :disabled="!pageUseCollection" v-model="categorySettings.useCollection">
        <label for="use_category_save_collection">{{ locale.allow }}</label>
      </div>
    </div>
    <!-- //담기 허용 -->
    <!-- 콜렉션 카테고리 -->
    <div v-if="categorySettings.useCollection" class="formGroup mb30">
      <div class="groupLabel mb5">{{ locale.mycollection_category }}</div>
      <div>
        <p v-if="pageUseCollection && categorySettings.useCollection && !vaidateCollectionCategory" class="colorRed">
          마이콜렉션 카테고리를 선택해주세요.
        </p>
        <MyCollectionCategoryTree v-if="myCollectionCategoryList && myCollectionCategoryList.length > 0"
          :locale="locale"
          :collectionCategory="vaidateCollectionCategory"
          :categoryList="myCollectionCategoryList"
          @update="updateCollectionCategory" />
        <div v-else class="colorGrey">{{ locale.message_mycollection_category_nodata }}</div>
      </div>
    </div>
    <!-- //콜렉션 카테고리 -->
    <!-- 리스트타입 -->
    <div class="formGroup mb30">
      <div class="groupLabel mb5">{{ locale.list_type }}</div>
      <div class="categoryListType">
        <span
          v-for="l in listTypes"
          :key="l"
          :class="{isActive: categorySettings.listType === l}"
          class="checkbox mr15">
          <input type="radio" name="category_list_type" :id="`category_list_type_${l}`" :value="l" v-model="categorySettings.listType" />
          <label :for="`category_list_type_${l}`">{{ locale[`layout_type_${l}`] }}</label>
          <div class="mt5 img">
            <img :src="require(`@/assets/img/img_categorytype_${l}.png`)" alt="">
          </div>
        </span>
      </div>
    </div>
    <!-- //리스트타입 -->
    <!-- 리스트 컬럼 수 -->
    <div class="formGroup mb30">
      <div class="groupLabel mb5">{{ locale.list_column_count }}</div>
      <input type="text" class="input sizeS" v-model="categorySettings.listColumn">
    </div>
    <!-- //리스트 컬럼 수 -->
    <!-- 리스트 컬럼 비율 -->
    <div class="formGroup mb30">
      <div class="groupLabel mb5">{{ locale.list_column_ratio }}</div>
      <div class="columnRatio">
        <span v-for="(column, index) in categoryColumns"
          :key="index"
          class="ratioItem">
          <input
            type="text"
            class="input"
            v-model="categorySettings.columnRatio[index]" />
        </span>
      </div>
    </div>
    <!-- //리스트 컬럼 비율 -->
    <!-- 아이템간격 -->
    <div class="formGroup mb30">
      <label class="groupLabel mb5">{{ locale.item_margin }}</label>
      <p class="sysMessage">{{ locale.message_shop_spacing_narrower }}</p>
      <div class="mb5">
        <label>{{locale.vertical}}</label>
        <InputRange
          :min="1"
          :max="5"
          :step="1"
          :minLabel="locale.narrow"
          :maxLabel="locale.wide"
          :value="categorySettings.itemMarginTb"
          @setRange="setRange('itemMarginTb', $event)" />
      </div>
      <div class="mb5">
        <label>{{locale.horizontal}}</label>
        <InputRange
          :min="1"
          :max="5"
          :step="1"
          :minLabel="locale.narrow"
          :maxLabel="locale.wide"
          :value="categorySettings.itemMarginLr"
          @setRange="setRange('itemMarginLr', $event)" />
      </div>
    </div>
    <!-- //아이템간격 -->
    <!-- 아이템 비율 -->
    <div v-if="categorySettings.listType === 'list'" class="formGroup mb30">
      <div class="groupLabel mb5">{{ locale.item_ratio }}</div>
      <span class="mr15">
        <span class="colorGrey mr5">{{ locale.image }}</span>
        <input type="text" class="input sizeS" v-model="categorySettings.itemRatio.image">
      </span>
      <span>
        <span class="colorGrey mr5">{{ locale.text }}</span>
        <input type="text" class="input sizeS" v-model="categorySettings.itemRatio.text">
      </span>
    </div>
    <!-- //아이템 비율 -->
    <!-- 이미지 비율 -->
    <div class="formGroup mb30">
      <div class="groupLabel mb5">{{ locale.image_ratio }}</div>
      <span class="mr15">
        <span class="colorGrey mr5">{{ locale.garo }}</span>
        <input type="text" class="input sizeS" v-model="categorySettings.imageRatio.width">
      </span>
      <span>
        <span class="colorGrey mr5">{{ locale.sero }}</span>
        <input type="text" class="input sizeS" v-model="categorySettings.imageRatio.height">
      </span>
    </div>
    <!-- //이미지 비율 -->
    <!-- 글자 크기 -->
    <div class="formGroup mb30">
      <div class="groupLabel mb5">{{ locale.font_size }}</div>
      <div class="setFontSize">
        <div class="fontItem">
          <span class="colorGrey mb5">{{ locale.name }}</span>
          <div class="unitInput">
            <input type="text" class="input" v-model="categorySettings.fontSize.name">
            <span class="unit">px</span>
          </div>
        </div>
        <div class="fontItem">
          <span class="colorGrey mb5">{{ locale.descTop }}</span>
          <div class="unitInput">
            <input type="text" class="input" v-model="categorySettings.fontSize.descTop">
            <span class="unit">px</span>
          </div>
        </div>
        <div class="fontItem">
          <span class="colorGrey mb5">{{ locale.descBottom }}</span>
          <div class="unitInput">
            <input type="text" class="input" v-model="categorySettings.fontSize.descBottom">
            <span class="unit">px</span>
          </div>
        </div>
      </div>
    </div>
    <!-- //글자 크기 -->
    <!-- 디스플레이 -->
    <div class="formGroup mb30">
      <div class="groupLabel mb5">{{ locale.display }}</div>
      <span class="checkbox mr15"
        v-for="d in displays"
        :key=d>
        <input type="checkbox" name="display_list" :id="`display_list_${d}`" :value="d" v-model="categorySettings.display" />
        <label :for="`display_list_${d}`">{{ locale[d] }}</label>
      </span>
    </div>
    <!-- //디스플레이 -->
  </div>
</template>

<script>
import InputRange from '@/components/Util/InputRange'
import MyCollectionCategoryTree from './MyCollectionCategoryTree'

export default {
  name: 'CollectionItemListSettings',
  props: [
    'locale',
    'pageId',
    'categoryId',
    'hasItem',
    'categorySettings',
    'pageUseCollection',
    'collectionCategory'
  ],
  components: {
    InputRange,
    MyCollectionCategoryTree
  },
  computed: {
    useCollection (isUse) {
      if (!isUse) {
        this.categorySettings.useCollection = false
      }
    },
    categoryColumns () {
      const column = this.categorySettings.listColumn
      return Number(column)
    },
    myCollectionCategoryList () {
      return this.$store.getters['collection/getMyCollectionCategory']
    },
    vaidateCollectionCategory () {
      const collectionCategory = this.collectionCategory
      const categoryList = this.myCollectionCategoryList
      const findCategory = this.findCategoryById(categoryList, collectionCategory)
      return findCategory?.categoryId || ''
    }
  },
  watch: {
    pageUseCollection (useCollection) {
      if (!useCollection) {
        this.categorySettings.useCollection = false
      }
    },
    categoryColumns (column) {
      const columnRatio = this.categorySettings.columnRatio
      this.categorySettings.columnRatio = Array.from({ length: column }, (_, i) => {
        return columnRatio[i] || '1'
      })
    },
  },
  data () {
    return {
      listTypes: [
        'gallery',
        'list'
      ],
      displays: [
        'image',
        'name',
        'descTop',
        'descBottom'
      ]
    }
  },
  methods: {
    setUseCollectionGroup (e) {
      e.preventDefault()
      if (window.confirm('아이템 그룹을 활성화 하시겠습니까?\n활성화 이후 비활성화할 수 없으며, 콜렉션 아이템은 그룹으로 관리됩니다.')) {
        this.categorySettings.useCollectionGroup.use = true
        this.$emit('saveCategorySetting')
      }
    },
    setItemClasses () {
      this.$emit('setItemClasses', true)
    },
    setRange (target, value) {
      this.categorySettings[target] = `${value}`
    },
    // categoryId로 전체 트리에서 카테고리 찾기
    findCategoryById (categories, id) {
      for (const cate of categories) {
        if (cate.categoryId === id) return cate
        if (cate.subCategory) {
          const found = this.findCategoryById(cate.subCategory, id)
          if (found) return found
        }
      }
      return null
    },
    // 가장 하위카테고리 찾기
    findDeepestId (startId) {
      const findCategoryById = (categories, id) => {
        for (const cat of categories) {
          if (cat.categoryId === id) return cat
          if (cat.subCategory) {
            const found = findCategoryById(cat.subCategory, id)
            if (found) return found
          }
        }
        return null
      }
      // 가장 깊은 leaf까지 재귀적으로 탐색
      const findDeepestLeaf = (category) => {
        if (!category || !category.subCategory || category.subCategory.length === 0) {
          return category
        }
        // 하위가 여러 개면 모든 경로 탐색하여 가장 깊은 leaf 리턴
        let deepest = null
        let maxDepth = 0
        const dfs = (node, depth) => {
          if (!node.subCategory || node.subCategory.length === 0) {
            if (depth > maxDepth) {
              maxDepth = depth
              deepest = node
            }
            return
          }
          for (const child of node.subCategory) {
            dfs(child, depth + 1)
          }
        }
        dfs(category, 1)
        return deepest
      }
      const startCategory = findCategoryById(this.myCollectionCategoryList, startId)
      if (!startCategory) return startId
      const deepest = findDeepestLeaf(startCategory)
      return deepest?.categoryId ?? startId
    },
    updateCollectionCategory (categoryId) {
      const selectedCategory = this.findCategoryById(this.myCollectionCategoryList, categoryId)
      if (selectedCategory) {
        const deepestId = this.findDeepestId(categoryId)
        this.$emit('updateCollectionCategory', deepestId)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.categoryListType {
  display: flex;
  .checkbox {
    flex: 1;
    margin: 0;
  }
  .img {
    width: 128px;
    border: 1px solid $color-lgrey2;
    border-radius: 4px;
    overflow: hidden;
  }
  .isActive {
    .img {
      border-color: $color-grey;
    }
  }
}
.columnRatio {
  display: flex;
  .ratioItem {
    flex: 1;
    flex-basis: 16.66%;
    & + .ratioItem {
      margin-left: 4px;
    }
  }
}
.setFontSize {
  display: flex;
  .fontItem {
    flex: 1;
    & + .fontItem {
      margin-left: 15px;
    }
  }
}
</style>